module.exports = __webpack_public_path__ + "media/images/illustrations/phone_notification_small-b2d01d99a7dea33b4f52e3c2702e939b.svg";